<section class="flex justify-content-center wrapper mb-5 mt-4 pt-1">
  <div class="wrapper-content flex-column">
    <a class="flex align-items-center gap-2 mb-3 no-underline text-blue-general" routerLink="/tramites/consulta-sisben">
      <i class="pi pi-arrow-left"></i>
      Volver a consulta
    </a>
    <CustomTitle [title]="'Consulta Sisben'"
                 styleClass="font-roboto-condensed color-form-label font-normal font-23 text-uppercase mt-3"/>
    @if (usuario(); as user ) {
      <div class=" d-flex justify-content-between p-3 bg-light grid md:flex-row ml-2">
        <div class="flex align-self-baseline col-4 lg:col-2  mb-3 md:mb-auto">
          <p-avatar [label]="user.nombreCompleto[0]"
                    size="xlarge" shape="circle"/>
          @if (user.jefeHogar) {
            <i class="pi pi-crown text-yellow-500" [pTooltip]="'Jefe hogar'"> </i>
          }
        </div>

        <div class="col-8 md:col-4 mb-2 md:mb-auto">
          <div class=" col-12">
            <label class="color-form-label">Nombre completo</label>
            <p class="m-0">{{ user.nombreCompleto }}</p>
          </div>

        </div>
        <div class="flex-column gap-1 flex max-w-12rem mx-auto md:mx-0">
          <div class="puntaje">
            {{ puntaje() ? puntaje() : 'N/A' }}
          </div>
          <label class="mt-1 mx-auto">Puntaje</label>
        </div>
      </div>

      <p-divider/>
      <div class="grid col">
        <div class=" col-12 md:col-6 ">
          <label class="color-form-label">Tipo de identificación</label>
          <p class="m-0">{{ user.tipoIdentificacion }}</p>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <label class="color-form-label">Identificación</label>
          <p class="m-0">{{ user.identificacion }}</p>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <label class="color-form-label">Genero</label>
          <p class="m-0">{{ user.genero ? user.genero : 'N/A' }}</p>
        </div>
        <div class="col-12 md:col-6">
          <label class="color-form-label">Dirección</label>
          <p class="m-0"> {{ user.direccion ? user.direccion : 'N/A' }}</p>
        </div>
        <div class="col-12 md:col-6">
          <label class="color-form-label">Barrio</label>
          <p class="m-0"> {{ user.barrio ? user.barrio : 'N/A' }}</p>
        </div>
        <div class="col-12 md:col-6">
          <label class="color-form-label">Teléfono</label>
          <p class="mt-0" [ngClass]="{'mb-1':user.telefonoMovil}"> {{ user.telefonoMovil }}</p>
          <p class="m-0"> {{ user.telefonoFijo }}</p>
          @if (!user.telefonoMovil && !user.telefonoFijo){
            <p class="m-0 text-gray-500">N/A</p>
          }
        </div>

        <div class="col-12 md:col-6">
          <label class="color-form-label">Correo</label>
          <p class="m-0">
            <a class="no-underline text-gray-600" [href]="'mailto:'+user.correo">
              {{ user.correo ? user.correo : 'N/A' }}
            </a>
          </p>
        </div>
      </div>
      <p-divider/>
      <div class="content p-3">
        <CustomTitle title="Nucleo familiar"
                     styleClass="font-roboto-condensed color-form-label font-normal font-18 text-uppercase my-3"/>
        @if (orgChartData.length) {
          <p-organizationChart [value]="orgChartData" [collapsible]="true">
            <ng-template let-node pTemplate="default">
              <div class="mx-4 my-3" [ngClass]="{ 'user-active': node.data.id == user.id }  " >
                <h5 class="text-blue-general text-lg max-w-18rem">{{ node.label }}</h5>
                <p>{{ node.data.tipoIdentificacion }}</p>
                <p> {{ node.data.identificacion }}</p>
                <p> {{ node.data.vinculo }}</p>
              </div>
            </ng-template>
          </p-organizationChart>
        } @else {
             <p class="text-center text-gray-500 my-5 ">No se encontraron datos del núcleo familiar</p>
        }


      </div>

    }@else if(!loading()) {
      <div class="card">
        <p-messages [(value)]="messages" [enableService]="false" />
        <a class="p-button-outlined p-button no-underline" routerLink="/tramites/consulta-sisben">
          volver
        </a>
      </div>
    }
  </div>
</section>

